module.exports = __webpack_public_path__ + "img/4-1.80078fd5.svg";